var _defs, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "search_svg__search",
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search_svg__cls-1{fill:inherit}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_svg__Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_svg__Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_svg__Path_1",
    d: "M6.164 0a6.164 6.164 0 106.164 6.164A6.171 6.171 0 006.164 0zm0 11.19a5.026 5.026 0 115.026-5.026 5.032 5.032 0 01-5.026 5.026z",
    className: "search_svg__cls-1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search_svg__Group_4",
    transform: "translate(9.597 9.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_svg__Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search_svg__Path_2",
    d: "M355.279 354.475l-3.262-3.262a.569.569 0 00-.8.8l3.262 3.262a.569.569 0 00.8-.8z",
    className: "search_svg__cls-1",
    transform: "translate(-351.046 -351.046)"
  })))));
}

export default SvgSearch;